import styled from 'styled-components';

export const RegistrationContainerStyled = styled.div``;
